import styled, { css } from "styled-components";
import Dropdown from "ui/common/components/input/Dropdown/Dropdown";

export const DatePickerDropdownRoot = styled(Dropdown)(
    ({ theme: { palette } }) => css`
        .SelectMenu.SelectMenu.SelectMenu {
            padding: 0;
            max-height: unset;
            width: auto;
        }
        .SelectDisplay {
            color: ${palette.primary};
        }
    `,
);
